export type PublishArtifactsResponse = {
  jazelId: string
  correlationId: string
  artifacts: any
}

export type PublishLogsResponse = {
  jazelId: string
  correlationId: string
  raw: string
  entries: any[]
}

export async function getPublishArtifacts(
  endpoint: string,
  jazelId: string,
  correlationId: string,
): Promise<PublishArtifactsResponse> {
  const url = `${endpoint}/publish-artifacts/${encodeURIComponent(jazelId)}/${encodeURIComponent(
    correlationId,
  )}`
  const res = await fetch(url, { method: 'GET' })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(text || `HTTP ${res.status} ${res.statusText}`)
  }
  return (await res.json()) as PublishArtifactsResponse
}

export async function getPublishLogs(
  endpoint: string,
  jazelId: string,
  correlationId: string,
  opts?: { maxLines?: number },
): Promise<PublishLogsResponse> {
  const qs = opts?.maxLines ? `?maxLines=${encodeURIComponent(String(opts.maxLines))}` : ''
  const url = `${endpoint}/publish-logs/${encodeURIComponent(jazelId)}/${encodeURIComponent(
    correlationId,
  )}${qs}`
  const res = await fetch(url, { method: 'GET' })
  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(text || `HTTP ${res.status} ${res.statusText}`)
  }
  return (await res.json()) as PublishLogsResponse
}


